import { reportServices } from '../services/reportService';
import { reportConstant, notificationConstant } from '../constants';
import { downloadCSV } from '../lib/downloadToCsv';

function getReport(param) {
    return dispatch => {
        dispatch({ type: notificationConstant.SHOW_LOADER, payload: {} })
        reportServices.getReport(param)
            .then(data => {
                dispatch({ type: reportConstant.REPORT_SELECTED_FILTERS, payload: param })
                dispatch({ type: notificationConstant.HIDE_LOADER, payload: {} })
                dispatch({ type: reportConstant.REPORT_DATA, payload: data })
            })
    }
}

function downloadDetail(param) {
    return () => {
        reportServices.getDetailReport(param)
            .then(data => {
                downloadCSV(data.report);
            })
    }
}
export const reportActions = {
    getReport,
    downloadDetail
};